<script setup lang="ts">
import {reactive, watch} from "vue";
import {Button, Drawer, InputText, Label} from "@/Components/Library";
import {inviteContact} from "@/Services/contacts";
import {saving} from "@/Composables/api";
import {useToast} from "primevue/usetoast";

const props = defineProps<{group?: any}>();
const model = defineModel<boolean>("visible");
const emit = defineEmits(["invited"]);
const defaultContact = {
    first_name: null,
    last_name: null,
    email: null,
};
const contact = reactive({...defaultContact});
const toast = useToast();
const save = async () => {
    try {
        const {data} = await inviteContact(contact, props.group?.id);
        emit("invited", data);
        Object.assign(contact, defaultContact);
        model.value = false;
        toast.add({
            severity: "success",
            summary: "Invitation sent",
            detail: "Your contact has been invited.",
            life: 5000,
        });
    } catch (e) {
        Object.assign(contact, defaultContact);
    }
};

watch(model, (value) => {
    if (!value) {
        Object.assign(contact, defaultContact);
    }
    console.log(props.group);
});
</script>
<template>
    <Drawer
        v-model:visible="model"
        position="bottom"
        header="Add a new contact"
        class="relative max-h-dvh max-w-3xl overflow-y-auto"
    >
        <template #closeicon>
            <Button :icon="{icon: 'mdi:times', width: 24}" @click="model = false" />
        </template>
        <form class="flex flex-col" @submit.prevent="save">
            <div class="mb-4 flex flex-col">
                <Label for="first_name" class="mb-1" required>First Name</Label>
                <InputText id="first_name" name="first_name" v-model="contact.first_name" required fluid />
            </div>
            <div class="mb-4 flex flex-col">
                <Label for="last_name" class="mb-1" required>Last Name</Label>
                <InputText id="last_name" name="last_name" v-model="contact.last_name" required fluid />
            </div>
            <div class="mb-4 flex flex-col">
                <Label for="email" class="mb-1" required>Email</Label>
                <InputText id="email" name="email" v-model="contact.email" type="email" required fluid />
            </div>
            <Button :loading="!!saving" class="bg-askr-green text-white hover:brightness-110" type="submit">Add</Button>
        </form>
    </Drawer>
</template>
<style scoped></style>
